import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import {
  Accordion,
  Icon,
  Dropdown,
  Button,
  Grid,
  Form,
  Input,
} from 'semantic-ui-react';
import {
  CommunicationConditons,
  CommunicationTodayOptions,
  OccuranceOptions,
} from '../../app/common/options/CommunicationConditions';
import { useStore } from '../../app/stores/store';

interface Props {
  handleDropdownChange: any;
  handleAddItem: any;
  chosenElemData: any;
  notificationDropdown: string;
}
function NotificationComponent({
  handleDropdownChange,
  handleAddItem,
  chosenElemData,
  notificationDropdown,
}: Props) {
  const { ApiStore, CommunicationStore } = useStore();
  const { communicationInput } = CommunicationStore;
  const [activeIndex, setActiveIndex] = useState(0);
  const [enableBetween, setEnableBetween] = useState<number[]>([]);
  //  const [optionsState,setOptionsState]=useState<any>([]);
  //  const [chosenElemData,setChosenElemData]=useState<any>([]);
  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const returnIndexCommunicationScheme = (selectedID: string) => {
    return communicationInput.getCommunicationInitScheme.findIndex(
      (item: any) => item.notificationContentId === selectedID,
    );
  };

  const handleConditionChange = (
    e: any,
    data: any,
    selectedID: string,
    dropdownName: string,
    index: number,
  ) => {
    let newArr = [...enableBetween];
    if (data.value === 'Between' || data.value === 'Not Between') {
      newArr[index] = 0;
      setEnableBetween(newArr);
    } else if (
      data.value === 'Contains' ||
      data.value === 'Not Contains' ||
      data.value === 'Beginning With' ||
      data.value === 'Ending With'
    ) {
      newArr[index] = 1;
      setEnableBetween(newArr);
    } else if (data.value === 'Date Occuring') {
      newArr[index] = 2;
      setEnableBetween(newArr);
    } else {
      //3 === Equal To
      newArr[index] = 3;
      setEnableBetween(newArr);
    }

    let condition_Data_Index = returnIndexCommunicationScheme(selectedID);
    communicationInput.getCommunicationInitScheme[condition_Data_Index][
      dropdownName
    ] = data.value;
  };

  const handleInputChange = (
    e: any,
    data: any,
    selectedID: string,
    dropdownName: string,
  ) => {
    let condition_Data_Index = returnIndexCommunicationScheme(selectedID);
    communicationInput.getCommunicationInitScheme[condition_Data_Index][
      dropdownName
    ] = e.currentTarget.value;
  };

  const handleDateChange = (
    date: any,
    type: string,
    selectedID: string,
    dropdownName: string,
    index: number,
  ) => {
    let condition_Data_Index = returnIndexCommunicationScheme(selectedID);
    let newString = date.target.value;
    let oldString =
      communicationInput.getCommunicationInitScheme[condition_Data_Index][
        dropdownName
      ];

    if (type === 'start') {
      if (!oldString.includes('/')) {
        communicationInput.getCommunicationInitScheme[condition_Data_Index][
          dropdownName
        ] = newString + '/';
      } else {
        let newSplitString = oldString.split('/'); //splitting
        newSplitString[0] = date.target.value; //changing first index
        let conjoinedDate = newSplitString.join('/'); //join again

        communicationInput.getCommunicationInitScheme[condition_Data_Index][
          dropdownName
        ] = conjoinedDate;
      }
    } else {
      if (!oldString.includes('/')) {
        communicationInput.getCommunicationInitScheme[condition_Data_Index][
          dropdownName
        ] = newString;
      } else {
        let newSplitString = oldString.split('/'); //splitting
        newSplitString[1] = date.target.value; //changing first index
        let conjoinedDate = newSplitString.join('/');
        communicationInput.getCommunicationInitScheme[condition_Data_Index][
          dropdownName
        ] = conjoinedDate;
      }
    }
  };
  const returnValueOfSelectedFields = (elem: string, fieldName: string) => {
    if (
      communicationInput.getCommunicationInitScheme[
        returnIndexCommunicationScheme(elem)
      ] !== undefined
    ) {
      return communicationInput.getCommunicationInitScheme[
        returnIndexCommunicationScheme(elem)
      ][fieldName];
    } else {
      return '';
    }
  };

  // const returnDateValueOfSelectedFields=(elem:string,fieldName:string)=>{
  //   return communicationInput.getCommunicationInitScheme[returnIndexCommunicationScheme(elem.split('/')[1])][fieldName]
  //  }
  return (
    <div>
      <Accordion styled fluid>
        <Accordion.Title
          style={{ backgroundColor: 'white' }}
          active={activeIndex === 1}
          index={1}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Notification
        </Accordion.Title>
        <Accordion.Content
          style={{ backgroundColor: 'white' }}
          active={activeIndex === 1}
        >
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Dropdown
                  placeholder="--Select--"
                  value={
                    notificationDropdown.includes('/')
                      ? notificationDropdown.split('/')[1]
                      : notificationDropdown
                  }
                  fluid
                  selection
                  options={ApiStore.selectedMetadataElement}
                  onChange={handleDropdownChange}
                />
              </Grid.Column>
              <Grid.Column>
                <Button
                  style={{ borderRadius: '30px' }}
                  positive
                  size="mini"
                  icon="plus"
                  onClick={handleAddItem}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>

          {chosenElemData.map((elem: any, index: number) => {
            return (
              <Grid>
                <Grid.Row columns={4}>
                  <Grid.Column>
                    <Form.Field
                      id="Type"
                      control={Input}
                      placeholder="Validation/Path"
                      value={elem.split('/')[0]}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Dropdown
                      placeholder="--Select Conditions--"
                      fluid
                      selection
                      options={CommunicationConditons}
                      clearable
                      name="conditons"
                      onChange={(e, data) =>
                        handleConditionChange(
                          e,
                          data,
                          elem.split('/')[1],
                          'conditons',
                          index,
                        )
                      }
                    />
                  </Grid.Column>
                  <Grid.Column>
                    {enableBetween[index] === 2 && (
                      <Dropdown
                        placeholder="Date"
                        fluid
                        // value={elem}
                        selection
                        options={CommunicationTodayOptions}
                        value={returnValueOfSelectedFields(
                          elem.split('/')[1],
                          'dateOccurane',
                        )}
                        onChange={(e, data) =>
                          handleConditionChange(
                            e,
                            data,
                            elem.split('/')[1],
                            'dateOccurane',
                            index,
                          )
                        }
                      />
                    )}

                    {enableBetween[index] === 0 && (
                      <div
                        style={{
                          display: 'flex',
                          width: '200px',
                        }}
                      >
                        <Form.Field required={true}>
                          <input
                            placeholder="Date"
                            style={{
                              width: '250px',
                              height: '36px',
                              borderRadius: '5px',
                              marginRight: '25px',
                              marginTop: '1px',
                            }}
                            name="dateOfReturn"
                            type="date"
                            defaultValue={''}
                            onChange={(e: any) =>
                              handleDateChange(
                                e,
                                'start',
                                elem.split('/')[1],
                                'dateOccurane',
                                index,
                              )
                            }
                          />
                        </Form.Field>
                        <Form.Field required={true}>
                          <input
                            placeholder="Date"
                            style={{
                              width: '250px',
                              height: '36px',
                              borderRadius: '5px',
                              marginTop: '1px',
                            }}
                            name="end"
                            type="date"
                            defaultValue={''}
                            disabled={
                              returnValueOfSelectedFields(
                                elem.split('/')[1],
                                'dateOccurane',
                              ).includes('/')
                                ? false
                                : true
                            }
                            onChange={(e: any) =>
                              handleDateChange(
                                e,
                                'end',
                                elem.split('/')[1],
                                'dateOccurane',
                                index,
                              )
                            }
                          />
                        </Form.Field>
                      </div>
                    )}

                    {enableBetween[index] === 1 && (
                      <Form.Field
                        placeholder="Enter a text"
                        fluid
                        control={Input}
                        name="conditons"
                        onChange={(e: any, data: any) =>
                          handleInputChange(
                            e,
                            data,
                            elem.split('/')[0],
                            'dateOccurane',
                          )
                        }
                      />
                    )}
                    {enableBetween[index] === 3 && (
                      <Form.Field
                        placeholder="Enter a number"
                        fluid
                        control={Input}
                        name="conditons"
                        onChange={(e: any, data: any) =>
                          handleInputChange(
                            e,
                            data,
                            elem.split('/')[0],
                            'dateOccurane',
                          )
                        }
                      />
                    )}
                  </Grid.Column>

                  <Grid.Column>
                    {enableBetween[index] >= 0 && (
                      <Dropdown
                        placeholder="Notification"
                        fluid
                        value={returnValueOfSelectedFields(
                          elem.split('/')[1],
                          'notificationOccurance',
                        )}
                        selection
                        options={OccuranceOptions}
                        clearable
                        onChange={(e, data) =>
                          handleConditionChange(
                            e,
                            data,
                            elem.split('/')[1],
                            'notificationOccurance',
                            index,
                          )
                        }
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            );
          })}
        </Accordion.Content>
      </Accordion>
    </div>
  );
}

export default observer(NotificationComponent);
